import styled, { css } from 'styled-components';

interface KeyProps {
  color?: string;
  active?: boolean;
  onClick?: () => void;
}

const dot = css<KeyProps>`
  &:before {
    content: '';
    display: inline-block;
    width: ${({ theme }) => theme.x1spacePx}px;
    height: ${({ theme }) => theme.x1spacePx}px;
    border-radius: ${({ theme }) => theme.x1spacePx}px;
    box-shadow: inset 0 0 1px 1px ${({ color }) => color};
    background: ${({ color, active = true }) =>
      active ? color : `transparent`};
    margin-right: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const Key = styled('button').attrs<KeyProps>(({ theme }) =>
  theme.focus('dashed')
)<KeyProps>`
  position: relative;
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme, active }) =>
    active ? theme.color.white : theme.color.whiteRGBA(0.7)};
  cursor: ${({ onClick }) => (onClick !== undefined ? `pointer` : `auto`)};
  text-transform: capitalize;
  height: 32px;
  background: ${({ theme, active, onClick }) =>
    onClick !== undefined && active
      ? theme.color.whiteRGBA(0.1)
      : 'transparent'};
  border-radius: ${({ theme }) => theme.x1spacePx / 2}px;
  padding: 0px 12px;
  ${({ theme, onClick, active }) =>
    onClick !== undefined &&
    !active &&
    `box-shadow: inset 0px 0px 0 1px ${theme.color.whiteRGBA(0.2)};`}
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx / 2}px;
  &:disabled {
    opacity: 0.3;
    cursor: auto;
    box-shadow: none;
    background: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  }
  ${({ color }) => color && dot}
  ${({ theme, onClick }) =>
    onClick !== undefined &&
    css`
      &:hover:enabled {
        background: ${theme.color.whiteRGBA(0.2)};
        box-shadow: none;
        color: ${theme.color.white};
      }
    `}
`;
